import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
	const { isDarkMode, toggleTheme } = useTheme();

	return (
		<button
			type="button"
			onClick={toggleTheme}
			className={`p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-border transition-colors ${className}`}
			aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
		>
			<i
				className={`fa-solid text-lg ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}
			/>
		</button>
	);
};

export default ThemeToggle;
